export default __webpack_public_path__ + "static/media/Minor Brew of Acumen.b9756fc4.jpg";